import { Download } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import { FormStrucItem } from 'src/lib/types/types';
import { InhaltTrenner, InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';

// import schemas
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { getAntragstellerName } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { DownloadStammdatenBlattForMA } from 'src/pages/private/online-antrag/DownloadAntragPDF';
import { hasChangedMittelabrufBankdaten } from 'src/utils/dashboardHelper';
const MA_P = MittelabrufSchema.attributes;
const StammdatenblattMA: FC<{}> = () => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const handleDownloadStammdatenBlatt = () => {
		DownloadStammdatenBlattForMA(application, readOnly, saveApplication);
	};
	return (
		<>
			<InhaltWrapper>
				<Typography variant='h4'>Download aktualisiertes Stammdatenblatt</Typography>
				<Typography>
					<strong>
						Bei Änderung der Kontoverbindung ist ein aktualisiertes, unterschriebenes Stammdatenblatt Voraussetzung für die Bearbeitung des
						Mittelabrufs.
					</strong>
					 Bitte laden Sie hier das neue Stammdatenblatt mit ihrer aktuellen Kontoverbindung herunter:
				</Typography>

				<Box sx={{ mt: '1rem' }}>
					<Stack spacing={3} sx={{ width: '100%', mt: '1rem' }}>
						<Button
							variant='outlined'
							startIcon={<Download />}
							onClick={() => handleDownloadStammdatenBlatt()}
							sx={{ maxWidth: 'fit-content' }}
						>
							Stammdatenblatt {getAntragstellerName(application)} herunterladen
						</Button>
					</Stack>

					<InhaltTrenner />

					<Stack spacing={3} sx={{ width: '100%', mt: '1rem' }}>
						<Typography variant='h4'>Upload Stammdatenblatt</Typography>

						<Typography>
							Bitte laden Sie hier Ihr unterzeichnetes Stammdatenblatt (pdf-Datei) als Vorab-Information über das Upload-Feld hoch:
						</Typography>
						<CreateForm
							formStruc={formStrucStammDatenblatt()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
							size='small'
						/>
						<Typography>
							<strong>Wichtig:</strong> Die Unterzeichnung des Stammdatenblatts muss per eigenhändiger Unterschrift erfolgen. Das Einfügen
							einer Bilddatei o.Ä. als Unterschrift ist nicht zulässig. Bitte speichern Sie das unterzeichnete Dokument anschließend als
							pdf-Datei ab und senden Sie uns das unterschriebene Original zusätzlich per Briefpost zu.
						</Typography>
					</Stack>
					<InhaltTrenner />
					<InhaltWrapper>
						<Typography variant={'h4'} component={'p'} sx={{ fontWeight: 600 }}>
							Einreichung des Stammdatenblatts
						</Typography>
						<Typography>Bitte lassen Sie uns das aktuelle Stammdatenblatt umgehend im Original zukommen.</Typography>
					</InhaltWrapper>
				</Box>
			</InhaltWrapper>
		</>
	);
};

export default StammdatenblattMA;

const formStrucStammDatenblatt = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Allgemein_Eingereichtes_Stammdatenblatt,
					allowedFileNameKeywords: ['Stammdatenblatt'],
					hideLabel: true,
				},
			],
			userProps: {
				columnToDivide: 1,
			},
		},
	];
	return struc;
};

export const getFormStrucStammdatenblattMA = (application: any) => {
	if (!hasChangedMittelabrufBankdaten(application)) return [];

	return concat(formStrucStammDatenblatt());
};
